import styles from "./InputCard.module.scss";
import { useTranslation } from "react-i18next";
import { TextField, FormControl, FormHelperText, InputLabel, Select, MenuItem, FormControlLabel, FormGroup, Checkbox } from "@mui/material";
import { Controller } from "react-hook-form";
import { useCallback } from "react";
import PaymentMethod from "./PaymentMethod";
import { constant } from "../misc/constant";
import Fileuploader from "./Fileuploader";
import _ from "lodash";
import { CheckBox } from "@mui/icons-material";

const InputCard = (props) => {
  const { t } = useTranslation();
  const { hookForm, paymentItmeProps, price } = props;
  const { control, getValues, setValue, trigger } = hookForm || {};

  const isValidConfrimEmail = useCallback((confirmEmail) => {
    const email = getValues("email");
    return email === confirmEmail ? true : t("Email Confrimation does not match email");
  }, []);

  const isValidYearOfBirth = useCallback((year) => {
    const minYear = 1900;
    const maxYear = new Date().getFullYear();
    return (year >= minYear && year <= maxYear) || !year ? true : t("Invalid Year of Birth");
  }, []);

  return (
    <div className={`card-view ${styles.card} ${props.xc || ""}`}>
      <div className="container">
        <h1 className="mb-1">{t("Fill in the information")}</h1>
        <div className="input-container mt-4">
          <div className="input-div full-width">
            <Controller
              key="prefix"
              name="prefix"
              control={control}
              defaultValue=""
              render={({ field, fieldState: { error } }) => (
                <div className="render-comp">
                  <FormControl variant="standard" sx={{ width: "100%" }} error={!!error}>
                    <InputLabel>{t("Prefix")}</InputLabel>
                    <Select
                      {...field}
                      onChange={(event) => {
                        setValue("prefix", event.target.value);
                        trigger("prefix");
                      }}
                    >
                      {constant.prefixList.map((item) => {
                        const str = t(item);
                        const key = _.uniqueId("menuitem_");
                        return (
                          <MenuItem key={key} value={str}>
                            {str}
                          </MenuItem>
                        );
                      })}
                    </Select>
                    {error ? <FormHelperText>{error.message}</FormHelperText> : null}
                  </FormControl>
                </div>
              )}
              rules={{ required: t("Required") }}
            />
          </div>
          <div className="input-div">
            <Controller
              key="chineseLastname"
              name="chineseLastname"
              control={control}
              defaultValue=""
              render={({ field, fieldState: { error } }) => (
                <TextField
                  sx={{ width: "100%" }}
                  label={t("Chinese lastname")}
                  variant="standard"
                  error={!!error}
                  helperText={error ? error.message : null}
                  {...field}
                />
              )}
            />
          </div>
          <div className="input-div">
            <Controller
              key="chineseFirstname"
              name="chineseFirstname"
              control={control}
              defaultValue=""
              render={({ field, fieldState: { error } }) => (
                <TextField
                  sx={{ width: "100%" }}
                  label={t("Chinese firstname")}
                  variant="standard"
                  error={!!error}
                  helperText={error ? error.message : null}
                  {...field}
                />
              )}
            />
          </div>
          <div className="input-div">
            <Controller
              key="englishLastname"
              name="englishLastname"
              control={control}
              defaultValue=""
              render={({ field, fieldState: { error } }) => (
                <TextField
                  sx={{ width: "100%" }}
                  label={t("English lastname")}
                  variant="standard"
                  error={!!error}
                  helperText={error ? error.message : null}
                  {...field}
                />
              )}
              rules={{ required: t("Required") }}
            />
          </div>
          <div className="input-div">
            <Controller
              key="englishFirstame"
              name="englishFirstame"
              control={control}
              defaultValue=""
              render={({ field, fieldState: { error } }) => (
                <TextField
                  sx={{ width: "100%" }}
                  label={t("English firstname")}
                  variant="standard"
                  error={!!error}
                  helperText={error ? error.message : null}
                  {...field}
                />
              )}
              rules={{ required: t("Required") }}
            />
          </div>
          <div className="input-div full-width">
            <Controller
              key="gender"
              name="gender"
              control={control}
              defaultValue=""
              render={({ field, fieldState: { error } }) => (
                <div className="render-comp">
                  <FormControl variant="standard" sx={{ width: "100%" }} error={!!error}>
                    <InputLabel>{t("Gender")}</InputLabel>
                    <Select
                      {...field}
                      onChange={(event) => {
                        setValue("gender", event.target.value);
                        trigger("gender");
                      }}
                    >
                      {constant.genderList.map((item) => {
                        const str = t(item);
                        const key = _.uniqueId("menuitem_");
                        return (
                          <MenuItem key={key} value={str}>
                            {str}
                          </MenuItem>
                        );
                      })}
                    </Select>
                    {error ? <FormHelperText>{error.message}</FormHelperText> : null}
                  </FormControl>
                </div>
              )}
            />
          </div>
          <div className="input-div">
            <Controller
              key="email"
              name="email"
              control={control}
              defaultValue=""
              render={({ field, fieldState: { error } }) => (
                <TextField sx={{ width: "100%" }} label={t("Email")} variant="standard" error={!!error} helperText={error ? error.message : null} {...field} />
              )}
              rules={{
                required: t("Required"),
                pattern: {
                  value: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
                  message: t("Invalid email"),
                },
              }}
            />
          </div>
          <div className="input-div">
            <Controller
              key="confirmEmail"
              name="confirmEmail"
              control={control}
              defaultValue=""
              render={({ field, fieldState: { error } }) => (
                <TextField
                  sx={{ width: "100%" }}
                  label={t("Confirm email")}
                  variant="standard"
                  error={!!error}
                  helperText={error ? error.message : null}
                  {...field}
                />
              )}
              rules={{
                required: t("Required"),
                pattern: {
                  value: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
                  message: t("Invalid email"),
                },
                validate: {
                  isValid: (value) => isValidConfrimEmail(value),
                },
              }}
            />
          </div>
          {/* <div className="input-div">
            <Controller
              key="phoneType"
              name="phoneType"
              control={control}
              defaultValue=""
              render={({ field, fieldState: { error } }) => (
                <FormControl variant="standard" sx={{ width: "100%" }} error={!!error}>
                  <InputLabel>{t("Phone type")}</InputLabel>
                  <Select
                    {...field}
                    onChange={(event) => {
                      setValue("phoneType", event.target.value);
                      trigger("phoneType");
                    }}
                  >
                    {constant.phoneTypeList.map((item) => {
                      const str = t(item);
                      const key = _.uniqueId("menuitem_");
                      return (
                        <MenuItem key={key} value={str}>
                          {str}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  {error ? <FormHelperText>{error.message}</FormHelperText> : null}
                </FormControl>
              )}
              rules={{ required: t("Required") }}
            />
          </div> */}
          <div className="input-div full-width">
            <Controller
              key="phoneNumber"
              name="phoneNumber"
              control={control}
              defaultValue=""
              render={({ field, fieldState: { error } }) => (
                <TextField
                  sx={{ width: "100%" }}
                  label={t("Phone No.")}
                  variant="standard"
                  {...field}
                  error={!!error}
                  helperText={error ? error.message : null}
                />
              )}
              rules={{
                required: t("Required"),
                pattern: {
                  value: /^[0-9]*$/,
                  message: t("Invalid Phone no."),
                },
                minLength: {
                  value: 8,
                  message: t("Invalid Phone no."),
                },
              }}
            />
          </div>
          <div className="input-div">
            <Controller
              key="birthYear"
              name="birthYear"
              control={control}
              defaultValue=""
              render={({ field, fieldState: { error } }) => (
                <TextField
                  sx={{ width: "100%" }}
                  label={t("Year of Birth")}
                  variant="standard"
                  {...field}
                  error={!!error}
                  helperText={error ? error.message : null}
                />
              )}
              rules={{
                validate: {
                  isValid: (value) => isValidYearOfBirth(value),
                },
              }}
            />
          </div>
          <div className="input-div">
            <Controller
              key="birthMonth"
              name="birthMonth"
              control={control}
              defaultValue=""
              render={({ field, fieldState: { error } }) => (
                <div className="render-comp">
                  <FormControl variant="standard" sx={{ width: "100%" }} error={!!error}>
                    <InputLabel>{t("Month of Birth")}</InputLabel>
                    <Select
                      {...field}
                      onChange={(event) => {
                        setValue("birthMonth", event.target.value);
                        trigger("birthMonth");
                      }}
                    >
                      {constant.monthList.map((item) => {
                        const str = t(item);
                        const key = _.uniqueId("menuitem_");
                        return (
                          <MenuItem key={key} value={str}>
                            {str}
                          </MenuItem>
                        );
                      })}
                    </Select>
                    {error ? <FormHelperText>{error.message}</FormHelperText> : null}
                  </FormControl>
                </div>
              )}
            />
          </div>
          <div className="input-div full-width">
            <Controller
              key="job"
              name="job"
              control={control}
              defaultValue=""
              render={({ field, fieldState: { error } }) => (
                <TextField sx={{ width: "100%" }} label={t("Job")} variant="standard" {...field} error={!!error} helperText={error ? error.message : null} />
              )}
            />
          </div>
          <div className="input-div full-width">
            <Controller
              key="livingArea"
              name="livingArea"
              control={control}
              defaultValue=""
              render={({ field, fieldState: { error } }) => (
                <div className="render-comp">
                  <FormControl variant="standard" sx={{ width: "100%" }} error={!!error}>
                    <InputLabel>{t("LivingArea")}</InputLabel>
                    <Select
                      {...field}
                      onChange={(event) => {
                        setValue("livingArea", event.target.value);
                        trigger("livingArea");
                      }}
                    >
                      {constant.livingAreaList.map((item) => {
                        const str = t(item);
                        const key = _.uniqueId("menuitem_");
                        return (
                          <MenuItem key={key} value={str}>
                            {str}
                          </MenuItem>
                        );
                      })}
                    </Select>
                    {error ? <FormHelperText>{error.message}</FormHelperText> : null}
                  </FormControl>
                </div>
              )}
            />
          </div>
          <div className="input-div full-width">
            <Controller
              key="files"
              name="files"
              control={control}
              defaultValue=""
              render={({ field, fieldState: { error } }) => (
                <Fileuploader label={t("Attachment")} error={!!error} trigger={() => trigger("files")} setValue={(v) => setValue("files", v)} />
              )}
            />
          </div>
        </div>
        <h1 className="mb-2">{t("Personal Information Collection Statement")}</h1>
        <ol className={`${styles.orderlist} mb-8`}>
          <li>
            <div>
              閣下向心呼吸〔「本機構」〕所提供的資料，包括《個人資料〔私隱〕條例》所指的個人資料，只會用於處理報名申請
              (包括通訊及意見收集)，以及分析或統計。除獲本機構授權的人員外，本機構不會將閣下的個人資料轉移給任何第三方。閣下必須向本機構提供完整的資料。如未能提供完整的資料，本機構或無法處理及/或考慮閣下的報名。
            </div>
          </li>
          <li>
            <div>
              閣下提供的個人資料（包括姓名、聯絡方法等）將用作與本機構溝通渠道，將與閣下分享本機構的事務通訊、課程、活動或募捐活動等推廣資訊。閣下若同意接收此等資訊，請於下列接收資訊欄之空格內加上「✔」。
            </div>
          </li>
          <div className="checkbox">
            <Controller
              key="pi-0"
              name="pi-0"
              control={control}
              defaultValue={true}
              render={({ field, fieldState: { error } }) => (
                <FormControl component="fieldset" error={error}>
                  <FormGroup>
                    <FormControlLabel control={<Checkbox {...field} defaultChecked />} label="本人同意接收由心呼吸發出的推廣資訊。" />
                    {error ? <FormHelperText sx={{ marginBottom: "16px" }}>{error.message}</FormHelperText> : null}
                  </FormGroup>
                </FormControl>
              )}
            />
            <div style={{ fontSize: "11px" }}>
              <i>
                若閣下日後不欲接收本機構的推廣資訊，可電郵至<a href="mailto:hello@pausebreathe.org"> hello@pausebreathe.org</a>。
              </i>
            </div>
          </div>
          <li>
            <div>本機構於活動期間會安排拍攝及錄影，日後或會使用有關照片及錄像供教學及宣傳之用。</div>
          </li>
          <div className="checkbox">
            <Controller
              key="pi-1"
              name="pi-1"
              control={control}
              defaultValue={true}
              render={({ field, fieldState: { error } }) => (
                <FormControl component="fieldset" error={error}>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox {...field} defaultChecked />}
                      label="本人同意心呼吸於活動中安排拍攝及錄影，並可使用有關照片及錄像作教學及宣傳之用。"
                    />
                    {error ? <FormHelperText>{error.message}</FormHelperText> : null}
                  </FormGroup>
                </FormControl>
              )}
            />
          </div>
          <li>
            <div>
              如閣下希望查閱或更改個人資料，請連同閣下已登記的姓名、電話號碼、電郵地址資料，電郵至
              <a href="mailto:hello@pausebreathe.org"> hello@pausebreathe.org</a>。
            </div>
          </li>
        </ol>
        {price && price > 0 ? (
          <>
            <h1 className="mb-5">{t("Select payment method")}</h1>
            <PaymentMethod xc="mb-2" paymentItmeProps={paymentItmeProps} />
          </>
        ) : null}
      </div>
    </div>
  );
};

export default InputCard;
